var config = {
  // title:  '河南晟权网络科技有限公司',
  // recordNo: '豫ICP备2022008195号',
  // address: '河南自贸试验区郑州片区（郑东）绿地原盛国际3号楼C座10层186室',
  // eMail: '649961456@qq.com',
  // domainName: 'hnsqzw.com',
  title:  '浙江续缘网络有限公司',
  recordNo: '浙ICP备2025150518号',
  address: '浙江省金华市义乌市稠江街道三鼎德欣智创园B栋2楼216（自主申报）',
  eMail: '649961456@qq.com',
  domainName: ''
}

module.exports = config
